import {useContext} from 'react';

import {ComparisonHoverContext} from '../contexts/ComparisonHoverContext';
import {ComparisonTestIdContext} from '../contexts/ComparisonTestIdContext';

export function useComparisonHover() {
  return {
    hasUnifiedSurfaces: useContext(ComparisonHoverContext),
    testId: useContext(ComparisonTestIdContext),
  };
}
